import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ActionIcon, Group, Menu, Text } from '@mantine/core';
import { IconBallpen, IconDots, IconTrash } from '@tabler/icons';
import TemplatePreview from '../Templates/TemplatePreview';
import { DocumentTemplateContext } from '../../../Service/Context/DocumentTemplateContext';
import { DocumentTemplateS } from '../../../Service/DocumenteTemplateS';
import { openDeleteConfirmModal } from '../../../Atoms/DeleteConfirmModal';
import { openRenameDocumentTemplateModal } from './DocumentTemplateModals';

const DocumentTemplateActions = () => {
  const { bookitupDocument } = useContext(DocumentTemplateContext);
  const navigate = useNavigate();

  const deleteHandler = () => {
    const onConfirm = async () => {
      if (bookitupDocument) {
        const { documentType, name } = bookitupDocument;
        const removed = await DocumentTemplateS.remove(documentType, name);
        if (removed) {
          navigate('/settings/templates');
          return true;
        }
      }
      return false;
    };
    openDeleteConfirmModal({
      title: 'Wirklich löschen',
      description: <Text>Möchtest Du dieses Dokument wirklich löschen?</Text>,
      onConfirm,
    });
  };

  return (
    <Group>
      <TemplatePreview name={bookitupDocument?.name} documentType={bookitupDocument?.documentType} style={undefined} />
      <Menu shadow="md" transition="scale-y" position="bottom-end">
        <Menu.Target>
          <ActionIcon>
            <IconDots />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            icon={<IconBallpen size={16} />}
            onClick={() =>
              bookitupDocument &&
              openRenameDocumentTemplateModal({
                templateId: bookitupDocument.id,
                templateName: bookitupDocument.name,
                documentType: bookitupDocument.documentType,
                onRename: (name: any) =>
                  navigate(`/settings/template/document/${bookitupDocument.documentType.toLowerCase()}/${name}`),
              })
            }
          >
            Namen ändern
          </Menu.Item>
          <Menu.Item color="red" onClick={deleteHandler} icon={<IconTrash size={16} />}>
            Löschen
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Group>
  );
};

export default DocumentTemplateActions;
